module.exports = __webpack_public_path__ + "img/LogoDashboard-28.82866c02.svg";